/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { useTheme } from '../../../../providers/theme';
import * as S from './styles';

export interface IIntendedPurpose {
  showModal?: boolean;
  required?: boolean;
  intendedPurposeTitle?: string;
  intendedPurposeSubTitle?: string;
  intendedPurposeLabel?: string;
  intendedPurposeOptions?: any;
  modelText1?: string;
  modelText2?: string;
  modelText3?: string;
  model1ConfirmButton?: string;
  model1CancelButton?: string;
  model2ConfirmButton?: string;
  model2CancelButton?: string;
  model3ConfirmButton?: string;
  defaultData?: any;
  button?: string;
  onAcknowledgement?(value: any): void;
  onDeny?(): void;
}

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const IntendedPurpose = (props: IIntendedPurpose) => {
  const theme = useTheme();
  const {
    intendedPurposeLabel,
    intendedPurposeOptions,
    intendedPurposeTitle,
    intendedPurposeSubTitle,
    modelText1,
    modelText2,
    modelText3,
    model1ConfirmButton,
    model1CancelButton,
    model2ConfirmButton,
    model2CancelButton,
    model3ConfirmButton,
    defaultData,
    button,
    onDeny,
    onAcknowledgement,
  } = props;
  const [intendedPurpose, setIntendedPurpose] = useState({
    ...intendedPurposeOptions,
    ...defaultData,
  });
  const [otherHomePolicy, setOtherHomePolicy] = useState<boolean>(false);
  const [otherHomePolicyTermsAccepted, setOtherHomePolicyTermsAccepted] =
    useState<boolean>(false);
  const intendedPurposeRef = useRef(null);

  const _onFormSubmit = async (event: any) => {
    event.preventDefault();
    for (let [key, value] of Object.entries(intendedPurpose)) {
      if (key === 'Housing' && value) {
        //@ts-ignore
        const modal1 = await SwalWithBootstrapButtons.fire({
          // icon: "warning",
          title: '',
          html: modelText1,
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonText: model1ConfirmButton,
          cancelButtonText: model1CancelButton,
        });
        if (modal1?.isConfirmed) {
          setOtherHomePolicy(true);
          const modal3 = await SwalWithBootstrapButtons.fire({
            // icon: "warning",
            title: '',
            text: modelText2,
            showCancelButton: true,
            allowOutsideClick: false,
            confirmButtonText: model2ConfirmButton,
            cancelButtonText: model2CancelButton,
          });
          if (modal3?.isConfirmed) {
            const modal4 = await SwalWithBootstrapButtons.fire({
              // icon: "warning",
              title: '',
              text: modelText3,
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: model3ConfirmButton,
            });

            if (modal4.isConfirmed) {
              let _temp = intendedPurpose;
              _temp.anotherHomePolicy = true;
              _temp.termsAccepted = true;
              if (event) {
                event.preventDefault();
                if (onAcknowledgement) {
                  onAcknowledgement(_temp);
                }
                // 👇️ clear all input values in the form
                event.target.reset();
              }
            }
          }
        }
        if (modal1?.isDismissed) {
          let _temp = intendedPurpose;
          _temp.anotherHomePolicy = otherHomePolicy;
          _temp.termsAccepted = otherHomePolicyTermsAccepted;
          if (event) {
            event.preventDefault();
            if (onAcknowledgement) {
              onAcknowledgement(intendedPurpose);
            }
            // 👇️ clear all input values in the form
            event.target.reset();
          }
        }
      }
    }
    if (!intendedPurpose['Housing']) {
      let _temp = intendedPurpose;
      _temp.anotherHomePolicy = otherHomePolicy;
      _temp.termsAccepted = otherHomePolicyTermsAccepted;
      if (event) {
        event.preventDefault();
        if (onAcknowledgement) {
          onAcknowledgement(_temp);
        }
        // 👇️ clear all input values in the form
        event.target.reset();
      }
    }
  };
  const onIntendedPurposeChange = (event: any) => {
    // console.log(`intended purpose change`, intendedPurpose);
    let tempObj = intendedPurpose;
    let tempSelection = {
      ...tempObj,
      [event.target.value]: event?.target?.checked,
    };
    setIntendedPurpose(tempSelection);
    console.log(`intended purpose change`, tempSelection);
  };
  return (
    <>
      <Form onSubmit={_onFormSubmit}>
        <Form.Group controlId="IntendedPurpose">
          <S.FormLabel color={theme?.colors?.primary}>
            {intendedPurposeLabel}
            <sup style={{ color: 'red' }}>*</sup>
          </S.FormLabel>
          {Object?.keys(intendedPurposeOptions)?.map(
            (item: string, i: number) => {
              return (
                <Form.Check
                  required={
                    intendedPurpose &&
                    !Object?.values(intendedPurpose)?.includes(true)
                  }
                  key={`${item}-${i}`}
                  label={item}
                  className="formcheck mt-2 mb-1"
                  ref={intendedPurposeRef}
                  name="intendedPurpose"
                  id={item}
                  value={item}
                  defaultChecked={intendedPurpose && intendedPurpose[item]}
                  onChange={onIntendedPurposeChange}
                />
              );
            }
          )}
        </Form.Group>
        <Button
          type="submit"
          className="text-dark me-3"
          size="lg"
          style={{ float: 'right' }}
          variant="secondary"
        >
          {button}
        </Button>
      </Form>
    </>
  );
};
IntendedPurpose.defaultProps = {
  showModal: false,
  required: false,
  intendedPurposeLabel: 'Intended Purpose of Insurance',
  intendedPurposeOptions: {
    'Livelihood Protection': false,
    Agriculture: false,
    Fisheries: false,
    Business: false,
    Housing: false,
  },
  button: 'Next',
};
